/**
 * Lista de 30/10 (B), itens 7.1 e 21: textos da cópia da negociação e da edição no lugar da ficha, em `pipeline:crm.copia.*`.
 * Arquivo próprio para não brigar com os outros lotes que mexem em `crm-i18n.ts` e `crm2-ficha-i18n.ts`.
 */
export const copiaPt = {
  menu: 'Copiar negociação',
  confirmarTitulo: 'Copiar negociação?',
  confirmarTexto:
    'A cópia leva tudo: os dados, os campos personalizados, a vertical, os produtos e serviços, as pessoas de contato, os questionários, as tarefas (sem o agendamento na Agenda), os arquivos e as propostas (como novas, sem o envio). O histórico da original aparece na cópia, abaixo da bandeirola.',
  copiada: 'Negociação copiada',
  marco: 'Criada como cópia de',
  marcoSemLink: 'Criada como cópia de outra negociação',
};

export const copiaEn: typeof copiaPt = {
  menu: 'Copy deal',
  confirmarTitulo: 'Copy deal?',
  confirmarTexto:
    'The copy takes everything: the details, custom fields, vertical, products and services, contact people, questionnaires, tasks (without the Calendar booking), files and proposals (as new ones, not sent). The original history shows on the copy, below the flag.',
  copiada: 'Deal copied',
  marco: 'Created as a copy of',
  marcoSemLink: 'Created as a copy of another deal',
};

export const copiaEs: typeof copiaPt = {
  menu: 'Copiar negociación',
  confirmarTitulo: '¿Copiar negociación?',
  confirmarTexto:
    'La copia lleva todo: los datos, los campos personalizados, la vertical, los productos y servicios, las personas de contacto, los cuestionarios, las tareas (sin la cita en la Agenda), los archivos y las propuestas (como nuevas, sin el envío). El historial de la original aparece en la copia, debajo de la bandera.',
  copiada: 'Negociación copiada',
  marco: 'Creada como copia de',
  marcoSemLink: 'Creada como copia de otra negociación',
};
